/*
 * default values for spinner
 */
export const SPINNER_SIZE = 'm';
export const CENTERED = false;
//# sourceMappingURL=config.js.map